import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { RouterProvider } from "./router/Router";
import "./index.css";
import "./help.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider>
      <App />
    </RouterProvider>
  </React.StrictMode>,
);
